import React from 'react'
import { TableSortLabel, Box, TableCell, Checkbox } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { styled } from '@mui/material/styles'
import { fontSizes } from '../Typography/TypographyStyles'
import { Column } from './TableTemplate'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  backgroundColor: theme.palette.background.paper,
  zIndex: theme.zIndex.appBar + 1,
}))

interface CustomTableHeaderCellProps {
  column: Column
  order: 'asc' | 'desc'
  orderBy: string
  handleRequestSort: (property: string) => void
  onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void
  numSelected?: number
  rowCount?: number
}

const CustomTableHeaderCell: React.FC<CustomTableHeaderCellProps> = ({
  column,
  order,
  orderBy,
  handleRequestSort,
  onSelectAllClick,
  numSelected = 0,
  rowCount = 0,
}) => (
  <StyledTableCell
    key={column.field}
    align={column.headerAlign || 'center'}
    style={{ width: column.width }}
    sortDirection={orderBy === column.field ? order : false}
    sx={{ fontSize: fontSizes.size12 }}
  >
    {column.field === 'selectBox' ? (
      <Checkbox
        indeterminate={numSelected > 0 && numSelected < rowCount}
        checked={rowCount > 0 && numSelected === rowCount}
        onChange={onSelectAllClick}
        inputProps={{
          'aria-label': 'select all',
        }}
      />
    ) : column.sortable ? (
      <TableSortLabel
        active={orderBy === column.field}
        direction={orderBy === column.field ? order : 'asc'}
        onClick={() => handleRequestSort(column.field)}
        sx={{
          display: 'flex',
          alignItems: column.headerAlign || 'center',
          justifyContent: 'center',
          '& .MuiTableSortLabel-icon': {
            visibility: orderBy === column.field ? 'visible' : 'hidden',
            marginLeft: orderBy === column.field ? '0' : '-1.5em',
          },
        }}
      >
        {column.headerName}
        {orderBy === column.field ? (
          <Box component='span' sx={visuallyHidden}>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </Box>
        ) : null}
      </TableSortLabel>
    ) : (
      column.headerName
    )}
  </StyledTableCell>
)

export default CustomTableHeaderCell
